import { Alert, Button } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useAutoRecipeEditor } from "./useAutoRecipeEditor";

export const AutoRecipeEditorAlerts = ({
  editor,
  refresh,
  disabled,
}: {
  editor: ReturnType<typeof useAutoRecipeEditor>;
  refresh: () => Promise<unknown>;
  disabled: boolean;
}) => {
  const { t } = useTenantTranslation();
  return (
    <>
      {editor.isStale ? (
        <Alert
          severity="warning"
          action={
            <Button disabled={disabled} onClick={editor.discard}>
              {t("discardChanges")}
            </Button>
          }
        >
          {t("autoDefaultsStale")}
        </Alert>
      ) : null}
      {editor.rejection ? (
        <Alert
          severity="error"
          action={
            editor.rejection.reason === "stale" ? (
              <Button
                disabled={disabled}
                onClick={() => {
                  void refresh();
                }}
              >
                {t("refresh")}
              </Button>
            ) : undefined
          }
        >
          {editor.rejection.message ?? t("autoInvalidParameters")}
        </Alert>
      ) : null}
      {editor.hasError ? (
        <Alert
          severity="warning"
          action={
            <Button disabled={disabled} onClick={editor.retry}>
              {t("retry")}
            </Button>
          }
        >
          {t("autoValidationFailed")}
        </Alert>
      ) : null}
    </>
  );
};
